import { ICipChatbotViewProps } from './cip-chatbot';
import React, { useState } from 'react';

export default (props: ICipChatbotViewProps) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    return (
        <>
            <div className={`cip-chatbot`}>
                <button
                    className='cip-chatbot__button'
                    onClick={() => {
                        setIsOpen(!isOpen);
                    }}
                ></button>
            </div>
            <div className={`cip-chatbot__frame ${isOpen ? 'cip-chatbot__frage--open' : 'cip-chatbot__frame--closed'}`}>
                {props.agentFrame}
            </div>
        </>
    );
};
